<template>
    <div class="container-fluid dashboard_default">
        <div class="row widget-grid">
            <breadCrumbs main="Dashboard" mains="Default" title="Shopping Place Dashboard" />
            <cardLevel1 />
            <recentOrders />
            <topSeller />
            <newProduct />
            <topCountries />
            <activityTimeline />
            <salesSummary />
            <weekendCard />
            <invoiceTable />
            <productSales />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const cardLevel1 = defineAsyncComponent(() => import("@/components/theme/dashboards/default/cardLevel1.vue"))
const recentOrders = defineAsyncComponent(() => import("@/components/theme/dashboards/default/recentOrders.vue"))
const topSeller = defineAsyncComponent(() => import("@/components/theme/dashboards/default/topSeller.vue"))
const newProduct = defineAsyncComponent(() => import("@/components/theme/dashboards/default/newProduct.vue"))
const topCountries = defineAsyncComponent(() => import("@/components/theme/dashboards/default/topCountries.vue"))
const activityTimeline = defineAsyncComponent(() => import("@/components/theme/dashboards/default/activityTimeline.vue"))
const salesSummary = defineAsyncComponent(() => import("@/components/theme/dashboards/default/salesSummary.vue"))
const weekendCard = defineAsyncComponent(() => import("@/components/theme/dashboards/default/weekendCard.vue"))
const invoiceTable = defineAsyncComponent(() => import("@/components/theme/dashboards/default/invoiceTable.vue"))
const productSales = defineAsyncComponent(() => import("@/components/theme/dashboards/default/productSales.vue"))
</script>